import { ZodiacLeoIcon } from './ZodiacLeoIcon';

/**
 * author: Michael Richins
 * id D280F50D-92FC-4DA2-BBAD-CE93140E6FEA
 * name zodiac-leo
 * version: 2.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/zodiac-leo.svg
 * tags
 */
export const HoroscopeLeoIcon = ZodiacLeoIcon;
export default HoroscopeLeoIcon